import type { Period } from '@silospot/shared';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { RangeParams } from '../lib/api';

interface PeriodState {
  period: Period;
  from?: string;
  to?: string;
  setPeriod: (period: Period) => void;
  setCustom: (from: string, to: string) => void;
}

/**
 * Dashboard-wide selected period, shared across the analytics sub-pages and
 * persisted to localStorage so the choice survives a page refresh.
 */
export const usePeriodStore = create<PeriodState>()(
  persist(
    (set) => ({
      period: '7d',
      setPeriod: (period) => set({ period, from: undefined, to: undefined }),
      setCustom: (from, to) => set({ period: 'custom', from, to }),
    }),
    { name: 'silospot.period' },
  ),
);

/** Derive the API range params from the current period state. */
export function usePeriodRange(): RangeParams {
  const { period, from, to } = usePeriodStore();
  return period === 'custom' ? { period, from, to } : { period };
}
